/**
 * @file
 * Time
 */

import * as React from 'react';

// Util
import { formatTime } from '../../util/util';

interface IProps {
  time: string;
}

const Time: React.FunctionComponent<IProps> = ({ time }) => (
  <time className="angler-catch__time" dateTime={time} data-testid="time">
    <span className="time__hours">{formatTime(time, 'hh')}</span>
    <span className="time__colon">:</span>
    <span className="time__minutes">{formatTime(time, 'mm')} </span>
    <span className="time__meridian">{formatTime(time, 'aa')}</span>
  </time>
);

export default Time;
